import { render, staticRenderFns } from "./ExpandableListParagraph.vue?vue&type=template&id=47c8a21e&scoped=true&"
import script from "./ExpandableListParagraph.vue?vue&type=script&lang=js&"
export * from "./ExpandableListParagraph.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableListParagraph.vue?vue&type=style&index=0&id=47c8a21e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8a21e",
  null
  
)

export default component.exports